import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Trans } from '@lingui/macro'

import CartList from '../../../containers/CartList/CartList'
import { Typography, Accordion, Button, Card, CartSummary, Column, Spinner } from 'components'
import Row from '../../../components/Row'

import { history } from '../../../routers/AppRouter'
import * as actions from '../../../redux/actions'
import * as routes from './../../../settings/_routesSettings'
import { formatCartItems, formatFloatToReal } from '../utils/orderUtils'

class Cart extends Component {
  state = { ordersFetched: false }

  componentDidMount = () => {
    this.props.onGetOrders(this.props.orderId).then(() => {
      formatCartItems(this.props.orderItems)
      this.setState({ ordersFetched: true })
    });
  }

  handleContinueButton = () => {
    history.push(routes.PAYMENT_CHECKOUT);
  }

  handleDeleteItem = (id) => {
    this.props.onDeletoOrderItem(this.props.orderId, id)
  }

  render() {
    const { ordersFetched } = this.state
    if (!ordersFetched) return (
      <div className="Cart">
        <Row align='center'
          justify='center'
          margin='2rem 0 0'>
          <Spinner />
        </Row>
      </div>
    )
    return (
      <div className="Cart">
        <Row align='center'
          justify='center'
          margin='2rem 0 0'>
          <Typography align='mcenter-dleft'
            type='heading4'
            style={{ width: '100%' }}>
            <Trans>Detalhes da compra</Trans>
          </Typography>
        </Row>
        <Row align='center'
          justify='center'
          margin='0 0 2rem'>
          <Typography align='mcenter-dleft'
            type='paragraph'
            color="grey-dark"
            style={{ width: '100%' }}>
            <Trans>Passo 1 de 3</Trans>
          </Typography>
        </Row>
        <Row>
          <Column colWidth={8}
            className="Cart__item-list">
            <Card classModifier="darkenBackground">
              <CartList itemList={formatCartItems(this.props.orderItems)}
                appointmentCategory={(<Trans>Agendamento</Trans>)}
                professionalName={this.props.orderProfessional}
                isDeletable
                onDelete={this.handleDeleteItem}
              />
            </Card>
          </Column>
          <Column colWidth={4}>
            <Row direction="column">
              <Row>
                <Accordion
                  title={(<Trans>Resumo da compra:</Trans>)}>
                  <CartSummary
                    isSuccinct={true}
                    discountValue={formatFloatToReal(this.props.orderDiscount)}
                    itemList={formatCartItems(this.props.orderItems)}
                    professionalName={this.props.orderProfessional}
                    sumValue={formatFloatToReal(this.props.orderTotal)}
                    totalValue={formatFloatToReal(this.props.orderTotal + this.props.orderDiscount)}
                  />
                </Accordion>
              </Row>
              <Row margin="15px 0">
                <Button text={(<Trans>Continuar</Trans>)}
                  onButtonClick={this.handleContinueButton}
                  disabled={formatCartItems(this.props.orderItems).length === 0}
                />
              </Row>
            </Row>
          </Column>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    orderDiscount: state.orders.discount,
    orderId: state.orders.orderId,
    orderItems: state.orders.items,
    orderProfessional: state.orders.professionalName,
    orderTotal: state.orders.total,
    order: state.orders,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetOrders: (orderId) => dispatch(actions.getOrders(orderId)),
    onDeletoOrderItem: (orderId, itemId) => dispatch(actions.deleteOrderItem(orderId, itemId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);